import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link, useParams } from "react-router-dom";

export const Blog = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/public/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="blog-page">
      <section className="bg-navy text-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="overline text-gold">Forte Journal</div>
          <h1 className="font-display text-4xl lg:text-6xl mt-4">Insights from the desk.</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white border border-slate-200 overflow-hidden hover:shadow-luxury transition" data-testid={`blog-card-${p.slug}`}>
            <div className="aspect-[5/3] overflow-hidden bg-slate-100">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <div className="overline text-gold">{p.author}</div>
              <h3 className="font-display text-xl text-navy mt-2 group-hover:text-gold transition">{p.title}</h3>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
};

export const BlogDetail = () => {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/public/blog/${slug}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [slug]);
  if (p === null) return <div className="p-20 text-center text-slate-500">Loading...</div>;
  if (p === false) return <div className="p-20 text-center text-slate-500">Article not found.</div>;
  return (
    <div data-testid="blog-detail">
      <section className="relative bg-navy text-white py-32 overflow-hidden">
        <img src={p.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative max-w-4xl mx-auto px-6 lg:px-10">
          <div className="overline text-gold">{p.author}</div>
          <h1 className="font-display text-4xl lg:text-5xl mt-4">{p.title}</h1>
        </div>
      </section>
      <article className="max-w-3xl mx-auto px-6 lg:px-10 py-16 prose-slate">
        <p className="text-lg text-slate-700 leading-relaxed">{p.body}</p>
      </article>
    </div>
  );
};
